import { makeStyles } from "@material-ui/core/styles";

import {
  defaultFont,
} from "assets/jss/material-dashboard-react.js";

const useUserProfileStyles = makeStyles({
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    ...defaultFont,
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    marginBottom: "3px",
    textDecoration: "none"
  }
});

export { useUserProfileStyles }